import React, { useState, useEffect } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';
import { useComponentLoading } from '../utils/useComponentLoading';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner';

const NewPettyCash = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [driverOptions, setDriverOptions] = useState([]);
    const [driverMap, setDriverMap] = useState({});
    const [pettyCashFields, setPettyCashFields] = useState([])
    const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();

    useEffect(() => {
        fetchDriverData();
    }, []);

    const fetchDriverData = async () => {
        try {
            await withLoading('fetchDrivers', async (updateProgress) => {
                updateProgress(10, 'Fetching driver data...');
                const params = new URLSearchParams({
                    page_size: 1000,
                    page: 1,
                });
                
                updateProgress(30, 'Making API request...');
                const response = await ApiManager.getAllDrivers(params);
                if (!response.ok) throw new Error('Network response was not ok');
                
                updateProgress(60, 'Processing response...');
                const json = await response.json();
                
                updateProgress(80, 'Preparing data...');
                const driverNames = json.map((driver) => driver.firstName + " " + driver.lastName);
                const driverIdMap = json.reduce((map, driver) => {
                    map[driver.firstName + " " + driver.lastName] = driver.id;
                    return map;
                }, {});
                
                updateProgress(90, 'Updating UI...');
                setDriverOptions(driverNames);
                setDriverMap(driverIdMap);
                updateProgress(100, 'Driver data loaded successfully');
            }, 'Loading driver data...');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        setPettyCashFields([
            ...(driverOptions.length > 0
                ? [{ label: 'Driver', name: 'driver_id', type: 'picklist', required: true, options: driverOptions }]
                : [{ label: 'Driver', name: 'driver_id', type: 'picklist', required: true, options:[]}]),
                { label: 'Petty cash given date', name: 'petty_cash_given', type: 'datetime-local', required: true },
                { label: 'Amount', name: 'amount', type: 'number', required: true },
                { label: 'Description', name: 'description', type: 'textarea', required: false }
            ]);
    }, [driverOptions]);

    const handleAddPettyCash = async (formData) => {
        try {
            const driverId = driverMap[formData.driver_id];
            const updatedFormData = { ...formData, driver_id: driverId };
            const response = await ApiManager.addPettyCash(updatedFormData);
            return response;
        } catch (error) {
            console.error('Error creating petty cash:', error);
            throw error;
        }
    };

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
            <button className="custom-button" onClick={toggleModal}>
                New Petty Cash
            </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                {isLoading('fetchDrivers') ? (
                    <LoadingSpinner 
                        size="medium" 
                        message={getMessage('fetchDrivers')}
                        progress={getProgress('fetchDrivers')}
                    />
                ) : (
                    <AddEntity
                        toggleFunction={toggleModal}
                        title="Add Petty Cash"
                        formFields={pettyCashFields}
                        apiFunction={handleAddPettyCash}
                        onSuccess={onSuccess}
                    />
                )}
            </Modal>
        </div>
    );
};

export default NewPettyCash;
